// removed by extract-text-webpack-plugin
module.exports = {"container":"settings__container___3KNCr","child-container":"settings__child-container___2MZaR","grid-spacing":"settings__grid-spacing___3EzFE"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/settings.scss
// module id = 521
// module chunks = 0